import { render, staticRenderFns } from "./BaseSubheader.vue?vue&type=template&id=1109d13f&"
import script from "./BaseSubheader.vue?vue&type=script&lang=js&"
export * from "./BaseSubheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports